import { render, staticRenderFns } from "./EmailVerifiedSuccess.vue?vue&type=template&id=8395cd02&scoped=true&"
import script from "./EmailVerifiedSuccess.vue?vue&type=script&lang=ts&"
export * from "./EmailVerifiedSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./EmailVerifiedSuccess.vue?vue&type=style&index=0&id=8395cd02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8395cd02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
